export default {
      Menus: 'System Menu|System Menus',
};
